import { Message } from '../../message';
export const MESSAGES = [new Message('', '')];
